import { parseDaysRange } from 'components/shared/DatePicker';

import { getFormattedDaysRange } from '../functions';
import { TInputDayPickerProps } from '../type';

export const DefaultValuePlank = function ({ mode, input }: TInputDayPickerProps) {
  if (!input.value) return null;

  if (mode === 'single') return <span>{`Day ${input.value}`}</span>;

  return <span>{getFormattedDaysRange(parseDaysRange(input.value))}</span>;
};
